import { IconTextArea } from './IconTextArea';
export default IconTextArea;
